import { usePastCoursesDatatable } from 'generated/resources/datatable.graphql'
import { FilterType } from 'generated/resources/datatable.graphql'
import { buildPastCoursesDatatableFilter } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { statusFilterOptions } from 'modules/trainings/components/Shared/Filters/StatusFileterOptions'

export const courseStatusFilter = (source: ReturnType<typeof usePastCoursesDatatable>) => {
  return buildPastCoursesDatatableFilter(source, {
    type: FilterType.String,
    default: true,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options: statusFilterOptions(),
      },
    ],
    identifier: 'attendanceStatusFilter',
    path: 'trainingAttendanceStatus',
    title: i18n.t('performance_process.targets.see_past_courses.status_column_name'),
  })
}
